import { TFunction } from 'react-i18next';
import { CampaignConversion } from 'modules/experiments/types';
import { MessageMedium } from 'modules/graphql';
import { settingsMetricsMediumWinningCriteriaDefaults } from '../constants';

enum WinningCriteriaEventCategoryId {
  CUSTOM = 'custom',
  SYSTEM = 'system',
}

export const getSystemEventSelectOptions = (
  t: TFunction,
  messageMedium: MessageMedium,
  isDisabled: boolean,
) => {
  return settingsMetricsMediumWinningCriteriaDefaults[messageMedium].map((event) => {
    return {
      ...event,
      id: event.value,
      label: t(event.label),
      categoryId: WinningCriteriaEventCategoryId.SYSTEM,
      isDisabled,
    };
  });
};

export const generateCustomEventSelectionOptions = (conversions: CampaignConversion[]) => {
  return conversions.map((conversion) => {
    return {
      id: `${conversion.id}`,
      label: conversion.name,
      value: conversion.name,
      categoryId: WinningCriteriaEventCategoryId.CUSTOM,
    };
  });
};
